var _a, _b;
import { CW_ENGAGEMENT_CARD_ID, CW_INSTRUCTOR_HOME_CARD_ID, SORT_DIRECTION } from 'constants/app.constant';
import { CW_INSTRUCTOR_HOME_CARD_TAB_ID } from './cw.constant';
export var SAFEMED_SCORE_SCALE = {
    atRisk: { max: 70, label: '<70' },
    belowAcceptable: { max: 90, label: '70-89' },
    acceptable: { max: 100, label: '90-99' },
    recommended: { label: '100' }
};
export var sortUpIcon = 'arrow-up';
export var sortDownIcon = 'arrow-down';
export var WARNING_COLOR = 'u-els-color-warn';
export var EMPOWER_ICON = 'EmpoweringKnowledge';
export var PLAY_VIDEO = 'PlayVideo';
export var INSERT_QUESTION = 'insert-question';
export var ASSIGNMENT_GRADES_TYPES = {
    GRADED: 'PASS_FAIL',
    GRADED_SCORED: 'SCORED'
};
export var ASSIGNMENT_TYPE_GROUPS = {
    EAQ: 'EAQ',
    NON_EAQ: 'NON_EAQ',
    AUTHESS: 'AUTHESS'
};
var VIKING_COLOR = 'u-custom-bg-color-viking';
var PERFUME_COLOR = 'u-custom-bg-color-perfume';
var TITAN_WHITE_COLOR = 'u-custom-bg-color-titan-white';
export var ASSIGNMENT_TYPES = {
    MASTERY: {
        id: 'MASTERY',
        name: 'EAQ Mastery',
        group: ASSIGNMENT_TYPE_GROUPS.EAQ,
        icon: 'eaq',
        isLinkedToOutsideApp: true,
        isCustomIcon: true,
        color: VIKING_COLOR
    },
    STANDARD: {
        id: 'STANDARD',
        name: 'EAQ Custom Quiz',
        group: ASSIGNMENT_TYPE_GROUPS.EAQ,
        icon: 'eaq',
        isLinkedToOutsideApp: true,
        isCustomIcon: true,
        color: VIKING_COLOR
    },
    QUIZ_BY_QUESTION: {
        id: 'QUIZ_BY_QUESTION',
        name: 'EAQ Custom Quiz by Question',
        group: ASSIGNMENT_TYPE_GROUPS.EAQ,
        icon: 'eaq',
        isLinkedToOutsideApp: true,
        isCustomIcon: true,
        color: VIKING_COLOR
    },
    AUTHESS: {
        id: 'AUTHESS',
        name: 'EAQ NGN',
        group: ASSIGNMENT_TYPE_GROUPS.EAQ,
        icon: 'eaq',
        isCustomIcon: true,
        isLinkedToOutsideApp: true,
        color: VIKING_COLOR
    },
    CASE_STUDY: {
        id: 'CASE_STUDY',
        name: 'SimChart Case Study',
        group: ASSIGNMENT_TYPE_GROUPS.NON_EAQ,
        icon: 'CaseStudy',
        isLinkedToOutsideApp: true,
        color: 'u-custom-bg-color-viking'
    },
    LESSONS: {
        id: 'LESSONS',
        name: 'Lesson',
        group: ASSIGNMENT_TYPE_GROUPS.NON_EAQ,
        icon: 'Lesson',
        isLinkedToOutsideApp: true,
        color: 'u-custom-bg-color-sulu'
    },
    ADAPTIVE_LESSON: {
        id: 'ADAPTIVE_LESSON',
        name: 'Lesson',
        group: ASSIGNMENT_TYPE_GROUPS.NON_EAQ,
        icon: 'Lesson',
        isLinkedToOutsideApp: true,
        color: 'u-custom-bg-color-sulu'
    },
    CHART: {
        id: 'CHART',
        name: 'SimChart Empty EHR',
        group: ASSIGNMENT_TYPE_GROUPS.NON_EAQ,
        icon: 'SimulationNursing',
        isLinkedToOutsideApp: true,
        color: 'u-custom-bg-color-cornflower'
    },
    SIMULATION: {
        id: 'SIMULATION',
        name: 'Simulation',
        group: ASSIGNMENT_TYPE_GROUPS.NON_EAQ,
        icon: 'Stethoscope',
        color: TITAN_WHITE_COLOR
    },
    SKILL: {
        id: 'SKILL',
        name: 'Skill',
        group: ASSIGNMENT_TYPE_GROUPS.NON_EAQ,
        icon: 'StopGesture',
        color: 'u-custom-bg-color-blizzard-blue'
    },
    SLS: {
        id: 'SLS',
        name: 'SLS(VR)',
        group: ASSIGNMENT_TYPE_GROUPS.NON_EAQ,
        icon: 'CaseStudy'
    },
    PERSONAL_ASSESSMENT_BUILDER: {
        id: 'PERSONAL_ASSESSMENT_BUILDER',
        name: 'Assessment Builder Assignment',
        group: ASSIGNMENT_TYPE_GROUPS.NON_EAQ,
        icon: EMPOWER_ICON,
        color: PERFUME_COLOR
    },
    SHADOW_HEALTH: {
        id: 'SHADOW_HEALTH',
        name: 'ShadowHealth',
        group: ASSIGNMENT_TYPE_GROUPS.NON_EAQ,
        icon: 'Lesson',
        isLinkedToOutsideApp: true,
        color: 'u-custom-bg-color-gorse'
    },
    OSMOSIS_VIDEO: {
        id: 'OSMOSIS_VIDEO',
        name: 'Osmosis',
        group: ASSIGNMENT_TYPE_GROUPS.NON_EAQ,
        icon: PLAY_VIDEO,
        color: 'u-custom-bg-color-azalea'
    },
    INTERACTIVE_REVIEW: {
        id: 'INTERACTIVE_REVIEW',
        name: 'Interactive Review Questions',
        group: ASSIGNMENT_TYPE_GROUPS.NON_EAQ,
        icon: INSERT_QUESTION,
        color: 'u-custom-bg-color-mauve',
        isCustomIcon: true
    },
    CUSTOM_LINK: {
        id: 'CUSTOM_LINK',
        name: 'Skill',
        group: ASSIGNMENT_TYPE_GROUPS.NON_EAQ,
        icon: 'Link',
        color: 'u-custom-bg-color-anakiwa'
    },
    EBOOK_READING: {
        id: 'EBOOK_READING',
        name: 'Skill',
        group: ASSIGNMENT_TYPE_GROUPS.NON_EAQ,
        icon: INSERT_QUESTION,
        color: 'u-custom-bg-color-fog',
        isCustomIcon: true
    },
    SLS_POST_SIMULATION_QUIZ: {
        id: 'SLS_POST_SIMULATION_QUIZ',
        name: 'Post-Simulation Quiz',
        group: ASSIGNMENT_TYPE_GROUPS.NON_EAQ,
        icon: 'SimulationImplementation',
        isNewBrandIconStyle: true,
        color: TITAN_WHITE_COLOR
    },
    SLS_SIMCHART_SIMULATION_EHR: {
        id: 'SLS_SIMCHART_SIMULATION_EHR',
        name: 'Simulation EHR',
        group: ASSIGNMENT_TYPE_GROUPS.NON_EAQ,
        icon: 'SimulationImplementation',
        isNewBrandIconStyle: true,
        color: TITAN_WHITE_COLOR
    },
    SLS_PRE_SIMULATION_QUIZ: {
        id: 'SLS_PRE_SIMULATION_QUIZ',
        name: 'Pre-Simulation Quiz',
        group: ASSIGNMENT_TYPE_GROUPS.NON_EAQ,
        icon: 'SimulationImplementation',
        isNewBrandIconStyle: true,
        color: TITAN_WHITE_COLOR
    },
    SLS_JOURNALING_EXERCISE: {
        id: 'SLS_JOURNALING_EXERCISE',
        name: 'Simulation Exercise',
        group: ASSIGNMENT_TYPE_GROUPS.NON_EAQ,
        icon: 'SimulationExercise',
        color: TITAN_WHITE_COLOR,
        isNewBrandIconStyle: true
    }
};
// Kept out of ASSIGNMENT_TYPES on purpose: that map is iterated elsewhere (e.g. student-assignment.helper.tsx)
// to build unrelated per-type filters, and this pseudo-type isn't a real backend contentType value.
export var ALL_EAQ_ASSIGNMENT_TYPE = {
    id: 'ALL_EAQ',
    name: 'All EAQ',
    group: ASSIGNMENT_TYPE_GROUPS.EAQ,
    icon: 'eaq',
    isCustomIcon: true,
    color: VIKING_COLOR
};
// Defined here (not in report.helper.tsx) so AssignmentTypeIcon.tsx can use it without a circular
// import - report.helper.tsx itself imports AssignmentTypeIcon.
export var getAssignmentTypeById = function (assignmentTypeId) {
    return assignmentTypeId === ALL_EAQ_ASSIGNMENT_TYPE.id ? ALL_EAQ_ASSIGNMENT_TYPE : ASSIGNMENT_TYPES[assignmentTypeId];
};
export var DATE_FORMATS = {
    DEFAULT: 'M/D/YYYY',
    LOCALE: 'll',
    TIMESTAMP: 'M/D/YYYY h:mm a',
    CUSTOM: 'YYYY/MM/DD'
};
export var eaqAssignmentConstants = {
    labels: {
        assignmentGrades: {
            notGraded: 'NOT_GRADED',
            graded: 'PASS_FAIL',
            gradedScored: 'SCORED'
        }
    }
};
export var eaqConstants = {
    assignmentType: {
        mastery: 'MASTERY',
        standard: 'STANDARD',
        quizByQuestion: 'QUIZ_BY_QUESTION'
    }
};
export var NAClassname = 'u-els-font-family-italic u-els-color-n7';
export var VALUE_NA = '-';
export var VALUE_NA_TEXT = 'N/A';
export var VALUE_NOT_APPLICABLE_TEXT = 'Not Applicable';
export var GRADEBOOK_PASS_FAIL = {
    pass: '1',
    fail: '0'
};
export var NO_DATA_FOUND = 'No Data Found';
export var NO_DUE_DATE = 'No Due Date';
export var CW_STUDENT_HOME_CARD_ID = {
    assignmentsAboveAvg: 'CW_ASSIGNMENTS_ABOVE_AVG',
    assignmentCompletedStatus: 'CW_ASSIGNMENT_COMPLETED_STATUS',
    topicInNoviceOrBellow: 'CW_TOPIC_IN_NOVICE_OR_BELLOW',
    selfStudyQuestionsAnswered: 'CW_SELF_STUDY_QUESTIONS_ANSWERED',
    eaqTopicReport: 'CW_EAQ_TOPIC_REPORT',
    createEAQQuiz: 'CW_EAQ_QUIZ_QUIZ'
};
export var CW_STUDENT_DETAIL_CARD_ID = {
    assignmentsAboveAvg: 'CW_STUDENT_DETAIL_ASSIGNMENTS_ABOVE_AVG',
    assignmentCompletedStatus: 'CW_STUDENT_DETAIL_ASSIGNMENT_COMPLETED_STATUS',
    topicInNoviceOrBellow: 'CW_STUDENT_DETAIL_TOPIC_IN_NOVICE_OR_BELLOW',
    selfStudyQuestionsAnswered: 'CW_STUDENT_DETAIL_SELF_STUDY_QUESTIONS_ANSWERED'
};
export var REPORT_TABLE_ID = {
    assignmentEngagement: 'ASSIGNMENT_ENGAGEMENT_TABLE',
    studentEngagement: 'STUDENT_ENGAGEMENT_TABLE'
};
export var ASSIGNMENT_SUMMARY_CARD_ID = {
    assignmentsCompleted: 'ASSIGNMENTS_COMPLETED',
    assignmentsWithPastDue: 'ASSIGNMENTS_WITH_PAST_DUE',
    assignmentsWithStudentsBelowClassAvg: 'ASSIGNMENTS_WITH_STUDENT_BELOW_CLASS_AVG'
};
export var PAST_DUE_ASSIGNMENTS_INFO_TOOLTIP = 'This is the number of assignments that have 15% of students who have not submitted the assignment prior to the due date.';
export var ENGAGEMENT_SUMMARY_CARD_ID = {
    completedAssignment: 'COMPLETED_ASSIGNMENTS'
};
export var STUDENT_HOME_ASSIGNMENT_SUMMARY_TABLE_SELECTORS = {
    scoreColumn: 'c-cw-student-home-assignment-summary-table__score-header-column',
    statusColumn: 'c-cw-student-home-assignment-summary-table__status-header-column'
};
export var STUDENT_HOME_ASSIGNMENT_ENGAGEMENT_TABLE_SELECTORS = {
    scoreColumn: 'c-cw-student-home-assignment-engagement-table__score-header-column',
    performanceComparedToClassAvg: 'c-cw-student-home-assignment-engagement-table__performance-compare-header-column'
};
export var STUDENT_DETAIL_ASSIGNMENT_SUMMARY_TABLE_SELECTORS = {
    scoreColumn: 'c-cw-student-detail-assignment-summary-table__score-header-column'
};
export var STUDENT_ENGAGEMENT_TABLE_SELECTOR = {
    studentAverageScoreColumn: 'c-cw-student-engagement-table__student-average-score-header-column',
    numberOfStudentsWithPastDueColumn: 'c-cw-student-engagement-table__number-of-student-with-past-due-header-column',
    timeSpentComparedToClassAvgColumn: 'c-cw-student-engagement-table__time-spent-compared-to-class-avg-header-column',
    selfStudyQuestionsAttemptedColumn: 'c-cw-student-engagement-table__self-study-questions-attempted-header-column'
};
export var ENGAGEMENT_TABLE_SELECTOR = {
    averageScoreColumn: 'c-cw-engagement-table__average-score-header-column',
    pastDueColumn: 'c-cw-engagement-table__past-due-header-column',
    belowClassAvgColumn: 'c-cw-engagement-table__below-class-avg-header-column'
};
export var ENGAGEMENT_TABLE_CARD_SORT_CONFIG = (_a = {},
    _a[CW_ENGAGEMENT_CARD_ID.classAverageScore] = {
        headerSelector: ENGAGEMENT_TABLE_SELECTOR.belowClassAvgColumn,
        field: 'totalAssignmentsBelowClassAvg',
        sortDirection: SORT_DIRECTION.DESC
    },
    _a[CW_ENGAGEMENT_CARD_ID.pastDueAssignments] = {
        headerSelector: ENGAGEMENT_TABLE_SELECTOR.pastDueColumn,
        field: 'pastDue',
        sortDirection: SORT_DIRECTION.DESC
    },
    _a[CW_ENGAGEMENT_CARD_ID.disengagedStudents] = {
        // Manually reordered by isAtRiskStudent instead of simulating a column-header click, so it never
        // touches any column's active-sort state (see EngagementTable's handling of manualSort).
        headerSelector: '',
        field: 'studentName',
        sortDirection: SORT_DIRECTION.ASC,
        manualSort: true
    },
    _a);
export var ASSIGNMENT_ENGAGEMENT_TABLE_SELECTORS = {
    completionColumn: 'c-cw-assignment-engagement-table__completion-header-column'
};
export var ASSIGNMENT_SUMMARY_TABLE_SELECTOR = {
    percentCompletedColumn: 'c-assignment-summary-table__percent-competed-header-column',
    numberOfPassDueColumn: 'c-assignment-summary-table__pass-due-header-column',
    classAvgScoreColumn: 'c-assignment-summary-table__class-avg-score-header-column'
};
export var INTERACTION_BETWEEN_CARD_AND_TABLE = (_b = {},
    _b[ASSIGNMENT_SUMMARY_CARD_ID.assignmentsCompleted] = {
        tableColumn: {
            headerSelector: ASSIGNMENT_SUMMARY_TABLE_SELECTOR.percentCompletedColumn,
            field: 'percentComplete'
        },
        sortDirection: SORT_DIRECTION.ASC
    },
    _b[ASSIGNMENT_SUMMARY_CARD_ID.assignmentsWithPastDue] = {
        tableColumn: {
            headerSelector: ASSIGNMENT_SUMMARY_TABLE_SELECTOR.numberOfPassDueColumn,
            field: 'totalStudentsPastDue'
        },
        sortDirection: SORT_DIRECTION.DESC
    },
    _b[ASSIGNMENT_SUMMARY_CARD_ID.assignmentsWithStudentsBelowClassAvg] = {
        tableColumn: {
            headerSelector: ASSIGNMENT_SUMMARY_TABLE_SELECTOR.classAvgScoreColumn,
            field: 'avgScore'
        },
        sortDirection: SORT_DIRECTION.ASC
    },
    _b[CW_ENGAGEMENT_CARD_ID.classAverageScore] = {
        tableColumn: {
            table: REPORT_TABLE_ID.studentEngagement,
            headerSelector: STUDENT_ENGAGEMENT_TABLE_SELECTOR.studentAverageScoreColumn,
            field: 'percentAvgScore'
        },
        sortDirection: SORT_DIRECTION.ASC
    },
    _b[CW_ENGAGEMENT_CARD_ID.assignmentCompleted] = {
        tableColumn: {
            table: REPORT_TABLE_ID.assignmentEngagement,
            headerSelector: ASSIGNMENT_ENGAGEMENT_TABLE_SELECTORS.completionColumn,
            field: 'percentCompletion'
        },
        sortDirection: SORT_DIRECTION.DESC
    },
    _b[CW_ENGAGEMENT_CARD_ID.numberOfStudentsWithPastDue] = {
        tableColumn: {
            table: REPORT_TABLE_ID.studentEngagement,
            headerSelector: STUDENT_ENGAGEMENT_TABLE_SELECTOR.numberOfStudentsWithPastDueColumn,
            field: 'pastDue'
        },
        sortDirection: SORT_DIRECTION.DESC
    },
    _b[CW_INSTRUCTOR_HOME_CARD_ID.assignmentCompleted] = {
        tableColumn: {
            headerSelector: ASSIGNMENT_SUMMARY_TABLE_SELECTOR.percentCompletedColumn
        },
        sortDirection: SORT_DIRECTION.ASC
    },
    _b[CW_INSTRUCTOR_HOME_CARD_ID.aboveClassAvg] = {
        tableColumn: {
            table: REPORT_TABLE_ID.studentEngagement,
            headerSelector: STUDENT_ENGAGEMENT_TABLE_SELECTOR.studentAverageScoreColumn
        },
        sortDirection: SORT_DIRECTION.DESC
    },
    _b[CW_STUDENT_DETAIL_CARD_ID.assignmentsAboveAvg] = {
        tableColumn: {
            headerSelector: STUDENT_DETAIL_ASSIGNMENT_SUMMARY_TABLE_SELECTORS.scoreColumn,
            field: 'score'
        },
        sortDirection: SORT_DIRECTION.ASC
    },
    _b[CW_STUDENT_HOME_CARD_ID.assignmentsAboveAvg] = {
        tableColumn: {
            headerSelector: STUDENT_HOME_ASSIGNMENT_ENGAGEMENT_TABLE_SELECTORS.performanceComparedToClassAvg
        },
        sortDirection: SORT_DIRECTION.ASC
    },
    _b[CW_INSTRUCTOR_HOME_CARD_TAB_ID.viewStudentEngagement] = {
        tableColumn: {
            table: REPORT_TABLE_ID.assignmentEngagement,
            headerSelector: ASSIGNMENT_ENGAGEMENT_TABLE_SELECTORS.completionColumn,
            field: 'percentCompletion'
        },
        sortDirection: SORT_DIRECTION.DESC
    },
    _b[CW_INSTRUCTOR_HOME_CARD_TAB_ID.viewAssignment] = {
        tableColumn: {
            headerSelector: ASSIGNMENT_SUMMARY_TABLE_SELECTOR.numberOfPassDueColumn,
            field: 'totalStudentsPastDue'
        },
        sortDirection: SORT_DIRECTION.DESC
    },
    _b[ENGAGEMENT_SUMMARY_CARD_ID.completedAssignment] = {
        tableColumn: {
            field: 'assignmentCompletionRate'
        },
        sortDirection: SORT_DIRECTION.DESC
    },
    _b);
export var sortLabelByType = {
    time: {
        asc: 'Most recent first',
        desc: 'Least recent first'
    },
    number: {
        asc: 'Low to high',
        desc: 'High to low'
    }
};
var iconPrefix = 'gizmo';
export var NEW_CW_DASHBOARD_ASSIGNMENT_SORT_OPTIONS = [
    {
        name: 'Due Date',
        value: 'dueDate',
        dependedOptions: [
            { name: sortLabelByType.time.asc, value: 'asc', icon: sortUpIcon, iconPrefix: iconPrefix },
            { name: sortLabelByType.time.desc, value: 'desc', icon: sortDownIcon, iconPrefix: iconPrefix }
        ]
    },
    {
        name: 'Completion Rate',
        value: 'percentComplete',
        dependedOptions: [
            { name: sortLabelByType.number.asc, value: 'asc', icon: sortUpIcon, iconPrefix: iconPrefix },
            { name: sortLabelByType.number.desc, value: 'desc', icon: sortDownIcon, iconPrefix: iconPrefix }
        ]
    },
    {
        name: 'Class Average Score',
        value: 'avgScore',
        dependedOptions: [
            { name: sortLabelByType.number.asc, value: 'asc', icon: sortUpIcon, iconPrefix: iconPrefix },
            { name: sortLabelByType.number.desc, value: 'desc', icon: sortDownIcon, iconPrefix: iconPrefix }
        ]
    },
    {
        name: 'Class Average Time Spent',
        value: 'avgTimeSpent',
        dependedOptions: [
            { name: sortLabelByType.number.asc, value: 'asc', icon: sortUpIcon, iconPrefix: iconPrefix },
            { name: sortLabelByType.number.desc, value: 'desc', icon: sortDownIcon, iconPrefix: iconPrefix }
        ]
    }
];
export var REPORT_DEPENDENT_OPTIONS = [{ parentOption: 'LESSONS', dependentOptionlist: ['ADAPTIVE_LESSON'] }];
export var PERCENT_ASSIGNMENTS_BELOW_CLASS_AVG_RED_CONDITION = 15;
export var PERCENT_ASSIGNMENTS_PASSED_DUE_RED_CONDITION = 50;
export var GRADEBOOK_ATTEMPT_OPTIONS = [
    {
        key: 'FIRST_ATTEMPT',
        name: 'First Attempt'
    },
    {
        key: 'FIRST_ATTEMPT_BEFORE_DUE_DATE',
        name: 'First Attempt (before due date)'
    },
    {
        key: 'LAST_ATTEMPT',
        name: 'Last Attempt'
    },
    {
        key: 'LAST_ATTEMPT_BEFORE_DUE_DATE',
        name: 'Last Attempt (before due date)'
    },
    {
        key: 'BEST_ATTEMPT',
        name: 'Best Attempt'
    },
    {
        key: 'BEST_ATTEMPT_BEFORE_DUE_DATE',
        name: 'Best Attempt (before due date)'
    },
    {
        key: 'AVERAGE_SCORE',
        name: 'Average Score'
    },
    {
        key: 'AVERAGE_SCORE_BEFORE_DUE_DATE',
        name: 'Average Score (before due date)'
    }
];
export var STUDENT_ROLE_SYNONYMS_ARRAY = ['Student', 'Stu'];
export var ONE_DECIMAL_PLACE = 1;
export var STUDENT_TABLE_INFO_CONTEXT_TEXT = 'The submission of this assignment after the due date resulted in a failing grade.';
